module.exports = __webpack_public_path__ + "img/certificate-5.f140a08b.jpg";